/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  CashBalanceTotal,
  FailureResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
  UniqueID,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns total of cash declarations and variance of all accounting locations
 * @summary Returns total of cash declarations and variance of all accounting locations
 */
export const getLatestCashDeclarationTotal = (signal?: AbortSignal) => {
  return customInstance<CashBalanceTotal>({
    url: `/BboCashManagementService/v1/cash-declarations/total`,
    method: 'get',
    signal,
  });
};

export const getGetLatestCashDeclarationTotalQueryKey = () => {
  return [`/BboCashManagementService/v1/cash-declarations/total`] as const;
};

export const getGetLatestCashDeclarationTotalQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestCashDeclarationTotalQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>> = ({
    signal,
  }) => getLatestCashDeclarationTotal(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestCashDeclarationTotalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>
>;
export type GetLatestCashDeclarationTotalQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Returns total of cash declarations and variance of all accounting locations
 */
export const useGetLatestCashDeclarationTotal = <
  TData = Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLatestCashDeclarationTotal>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLatestCashDeclarationTotalQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Returns unique id using uuid and timestamp
 * @summary Returns unique id using uuid and timestamp
 */
export const getUniqueId = (signal?: AbortSignal) => {
  return customInstance<UniqueID>({
    url: `/BboCashManagementService/v2/get-unique-id`,
    method: 'get',
    signal,
  });
};

export const getGetUniqueIdQueryKey = () => {
  return [`/BboCashManagementService/v2/get-unique-id`] as const;
};

export const getGetUniqueIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getUniqueId>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUniqueId>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUniqueIdQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUniqueId>>> = ({ signal }) =>
    getUniqueId(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUniqueId>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetUniqueIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUniqueId>>>;
export type GetUniqueIdQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Returns unique id using uuid and timestamp
 */
export const useGetUniqueId = <
  TData = Awaited<ReturnType<typeof getUniqueId>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getUniqueId>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUniqueIdQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
